var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('strong',{staticStyle:{"color":"#5A646E"},attrs:{"tabindex":"0"},domProps:{"textContent":_vm._s(_vm.$ml.get('purchaseSummary'))}}),_c('small',{staticClass:"text-secondary d-block mt-2",attrs:{"tabindex":"0"}},[_vm._v(_vm._s(_vm.MerchantName))]),_c('CartItems')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }